import {combineReducers} from "redux";
import {authReducer} from "./reducers/authReducers";
import {nftReducer} from "./reducers/nftReducers";
import {authFeatureKey,nftFeatureKey} from "./featureKeys";

export const rootReducer=combineReducers({
    [authFeatureKey]:authReducer,
    [nftFeatureKey]:nftReducer,

});
